'use strict';

var MarketDateRangeLevelChartFilterFactory = function MarketDateRangeLevelChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function MarketDateRangeLevelChartFilter() {
    DemandFilter.call(this, 'market', 'date-range-level-chart');
    this.registerFilters(injectedFilters);
  }
  MarketDateRangeLevelChartFilter.constructor = MarketDateRangeLevelChartFilter;
  MarketDateRangeLevelChartFilter.prototype = Object.create(DemandFilter.prototype);
  return MarketDateRangeLevelChartFilter;
};
MarketDateRangeLevelChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketDateRangeLevelChartFilterFactory;